import TableFieldRenderer from './TableFieldRenderer/tableFieldRenderer';
import FormFieldRenderer from './FormFieldRenderer/formFieldRenderer';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { listStore } from 'store/mobx/list.store';

const UserFieldsRenderer = observer(({ forTable = false, type, item, ...rest }) => {
  const [needTime, setNeedTime] = useState(false);
  const { units, userList, barcodes } = listStore;

  const getWeight = () => {
    const max_size = item?.setting?.max_size;
    return max_size + 'Mb';
  };

  const commonProps = {
    item,
    userList,
    units,
    needTime,
    getWeight,
    barcodes,
    ...rest,
  };

  useEffect(() => {
    setNeedTime(item?.setting?.time ?? false);
  }, [item]);

  switch (true) {
    case forTable:
      return <TableFieldRenderer type={type} {...commonProps} forTable={forTable} />;
    default:
      return <FormFieldRenderer type={type} {...commonProps} />;
  }
});

UserFieldsRenderer.propTypes = {
  type: PropTypes.string,
  forTable: PropTypes.bool,
};

export default UserFieldsRenderer;
